import { Accordion, AccordionDetails, AccordionSummary, useStyles } from './styles'
import { PaywallDisplay, getAuthError, setDisplayState } from 'redux/slices/paywall'

import { getShowPassList } from 'redux/slices/passes'
import React, { useCallback, useEffect, useState } from 'react'
import { bindActionCreators, compose } from 'redux'
import { connect, useDispatch, useSelector } from 'react-redux'
import { faChevronRight, faWindowClose } from '@fortawesome/free-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Typography from '@material-ui/core/Typography'
import clsx from 'clsx'
import { isString } from 'lodash'
import CallToActionButton from 'components/common/CallToActionButton/CallToActionButton'
import { useAuth0, LoginAction } from 'libs/web-client/utils/auth0/src'
import usePrevious from 'hooks/use-previous'

const PaywallPurchaseSuccessSignup = () => {
    const { loginWithPopup, isAuthenticated } = useAuth0()
    const prevIsAuth = usePrevious(isAuthenticated)
    const classes = useStyles()
    const [formChanged, setFormChanged] = useState(false)
    const [fadeOut, setFadeOut] = useState(false)
    const [expanded, setExpanded] = useState()
    const dispatch = useDispatch()
    const passes = useSelector(getShowPassList)
    const authError = useSelector(getAuthError)
    const currentPass = passes[0]

    const fadeOutNow = useCallback(() => {
        setFadeOut(true)
        dispatch(setDisplayState(PaywallDisplay.ACCESS))
    }, [dispatch])
    const handleLoginClick = useCallback(() => loginWithPopup({ action: LoginAction.LOGIN }), [loginWithPopup])
    const onSignUpSubmit = useCallback(() => loginWithPopup({ action: LoginAction.REGISTER }), [loginWithPopup])
    const handleExpansionChange = useCallback(
        panel => (event, newExpanded) => {
            setExpanded(newExpanded ? panel : false)
        },
        [setExpanded],
    )

    useEffect(() => {
        let timer
        if (!formChanged) {
            const wait = 90000
            timer = setTimeout(fadeOutNow, wait)
        } else {
            clearTimeout(timer)
            setFormChanged(false)
        }
        return () => clearTimeout(timer)
    }, [formChanged, fadeOutNow])

    useEffect(() => {
        if (isAuthenticated && !prevIsAuth) {
            dispatch(setDisplayState(PaywallDisplay.SUCCESS_CONFIRMATION))
        }
    }, [isAuthenticated, prevIsAuth, dispatch])

    const email = currentPass.email
    const redemptionCode =
        currentPass && isString(currentPass.redemptionCode) && currentPass.redemptionCode.toUpperCase()

    return (
        <div className={clsx(classes.container, fadeOut && [classes.fadeOut])} id="paywall-success-container">
            <div onClick={fadeOutNow} className={classes.close}>
                <FontAwesomeIcon icon={faWindowClose} />
            </div>
            <h3 className={classes.heading}>Purchase Successful!</h3>
            <p className={classes.code}>{redemptionCode}</p>
            <p className={classes.subheading}>Your confirmation code has been sent to {email}.</p>

            <Accordion square expanded={expanded === `code-0`} onChange={handleExpansionChange(`code-0`)}>
                <AccordionSummary
                    expandIcon={<FontAwesomeIcon className={classes.chevronRightIcon} icon={faChevronRight} />}
                    aria-controls={`code-0-content`}
                    id={`code-0-header`}
                >
                    <Typography component={'div'}>
                        <div className={classes.expansionSummary}>What is this code?</div>
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography component={'div'}>
                        <div>
                            <p className={classes.subheading}>There are a few main things you should know:</p>
                            <ol>
                                <li className={classes.subheading}>
                                    Without an account, this Confirmation Code will act as your ticket to access the
                                    event
                                </li>
                                <li className={classes.subheading}>
                                    Without an account, you won’t be able to participate in the LIVE parts of the event
                                </li>
                            </ol>
                            <p className={classes.subheading}>
                                For an experience that is stress-free and guaranteed to be better, we recommend creating
                                an account below.
                            </p>
                        </div>
                    </Typography>
                </AccordionDetails>
            </Accordion>

            <h3 className={clsx(classes.heading, classes.createAccountHeading)}>Create your account</h3>
            <p className={classes.subheading}>Your purchased pass will automatically save to your account.</p>

            {authError && <div className={classes.authError}>{authError}</div>}

            <div className={classes.authForm}>
                <p className={classes.subheading}>
                    Already have an account?
                    <button className={classes.signInLink} onClick={handleLoginClick}>
                        Sign in to your account
                    </button>
                </p>
                <div className={classes.authForm}>
                    <CallToActionButton
                        onClick={onSignUpSubmit}
                        text="Create Account"
                        display="block"
                        type="secondary"
                        className={classes.signupBtn}
                        id="paywall-sign-up-submit-btn"
                    />
                </div>
            </div>
        </div>
    )
}

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            setDisplayState,
        },
        dispatch,
    )

export default compose(connect(null, mapDispatchToProps), React.memo)(PaywallPurchaseSuccessSignup)
